<template>
  <div>
    <DealPicker ref="editDealsModal" @onDealsPicked="onDealsPicked"/>
    <b-card no-body class="mb-1 mt-1">
      <b-card-body>
        <div class="text-left">
          <header class="caption table-caption text-left p-1">Model Management</header>
          <b-row class="mt-3">
            <b-col cols="2" class="text-right">
              &nbsp;
            </b-col>
            <b-col>
              <label class="file-select">
              <span class="btn btn-info">
                <span>Load ADco Grid from XLSX</span>
              </span>
                <span>
                {{ pickedFileName }}
              </span>
                <input id="file-xlsx-select" type="file" @change="handleFileChange"/>
              </label>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="2" class="text-right">
              <label for="deal-name">
                Deal Name:
              </label>
            </b-col>
            <b-col>
              <b-input-group>
                <b-btn @click="actOpenDealPicker">Deal Picker</b-btn>
                <b-form-input class="text-left" v-model="dealName" placeholder="eg.: CAS 2017-C07B, STACR 2021-DNA9" id="deal-name"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="2" class="text-right">
              <label for="settlement-date">
                Settlement Date:
              </label>
            </b-col>
            <b-col>
              <b-form-group style="width: 13ch">
                <datepicker
                    id="settlement_date"
                    :clearable="false"
                    class="w-100"
                    input-class="form-control text-right calculation-settings-input"
                    type="date"
                    format="MM/DD/YYYY"
                    lang="en"
                    v-model="settlementDate"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-btn :disabled="adcoScenarios.length == 0" @click="runAdcoVectors" variant="primary">Run ADco vectors</b-btn>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <table v-if="arrProgressReport.length > 0" class="table table-sm">
                <thead>
                <tr class="header">
                  <th>Deal Name</th>
                  <th>Scenario Name</th>
                  <th>Server Response</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in arrProgressReport">
                  <td class="pct-w-20">{{ item.DealName }}</td>
                  <td class="pct-w-20">{{ item.ScenarioName }}</td>
                  <td :class="[item.Result.statusTagClass]">
                    {{ item.Result.statusReport }}
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import * as XLSX               from "xlsx";
import RequestBodyFactory from "@/services/RequestBodyFactory";
import service            from "@/services/HttpRequestService";
import ObjAlertState      from "@/components/common/alert/ObjAlertState";
import ObjSpinnerState    from "@/components/common/spinner/ObjSpinnerState";
import ManagerRequest     from "@/services/ManagerRequest";
import classStatusItem    from "@/components/adminAdco/classStatusItem";
import * as UtilsArray    from "@/utilities/ArrayUtils";
import Datepicker         from 'vue2-datepicker';
import DealPicker         from './DealPicker';

export default {
  name: 'AdminAdco',
  data() {
    return {
      dealName:          '',
      settlementDate:    new Date(),
      adcoScenarios:     [],
      arrProgressReport: [],
      pickedFileName:    '',
      ObjAlertState,
      ObjSpinnerState
    }
  },
  methods:    {
    actOpenDealPicker() {
      this.$refs.editDealsModal.showModal();
    },
    onDealsPicked(dealsSelected = []) {
      this.dealName = dealsSelected.join(', ');
    },
    handleFileChange(ev) {
      const scenariosExcelFile = ev.target.files && ev.target.files.length > 0 ? ev.target.files[0] : null;
      if (!scenariosExcelFile) {
        return;
      }
      this.pickedFileName  = ev.target.value.replace(/^.*[\\\/]/, '');
      const reader         = new FileReader();
      reader.onload        = e => {
        const bstr = e.target.result;
        try {
          ObjSpinnerState.isOn = true;
          const wb             = XLSX.read(bstr, {type: 'binary'});
          const tsy2Sheet      = wb.SheetNames[0];
          const tsy10Sheet     = wb.SheetNames[1];
          const hpiSheet       = wb.SheetNames[2];
          const tunSheet       = wb.SheetNames[3];
          const wsTsy2         = wb.Sheets[tsy2Sheet];
          const wsTsy10        = wb.Sheets[tsy10Sheet];
          const wsTsyHpi       = wb.Sheets[hpiSheet];
          const wsTune         = wb.Sheets[tunSheet];
          const dataTsy2       = XLSX.utils.sheet_to_json(wsTsy2, {header: 1});
          const dataTsy10      = XLSX.utils.sheet_to_json(wsTsy10, {header: 1});
          const dataHpi        = XLSX.utils.sheet_to_json(wsTsyHpi, {header: 1});
          const dataTune       = XLSX.utils.sheet_to_json(wsTune, {header: 1});
          this.adcoScenarios   = [];
          // if(!Array.isArray(data) || !data.length) {
          //   this.$refs.alert.showAlert("danger", "No data in " + file.name + " file found.");
          //   return;
          // }
          for (let scenarioNum = 1; scenarioNum < dataTsy2[0].length; scenarioNum++) {
            let scenario = {};
            let tsy2     = [];
            let tsy10    = [];
            let hpi      = [];
            for (let y = 1; y < dataTsy2.length; y++) {
              tsy2.push(dataTsy2[y][scenarioNum]);
              tsy10.push(dataTsy10[y][scenarioNum]);
              if (y < dataHpi.length - 1) {
                let hpiVal =
                        dataHpi[y + 1][scenarioNum] == undefined
                        ? hpi[hpi.length - 1]
                        : dataHpi[y + 1][scenarioNum];
                hpi.push(hpiVal);
              }
            }
            scenario.Name         = dataTsy2[0][scenarioNum];
            scenario.Tsy2Year     = tsy2;
            scenario.Tsy10Year    = tsy10;
            scenario.Hpi          = hpi;
            scenario.TuneCpr      = dataTune[5][scenarioNum];
            scenario.TuneCdr      = dataTune[4][scenarioNum];
            scenario.TuneSeverity = dataTune[3][scenarioNum];
            this.adcoScenarios.push(scenario);
          }
        } catch (err) {
          ObjAlertState.set(err.message, 3);
        } finally {
          ObjSpinnerState.isOn = false;
        }
      };
      reader.onloadend     = (ev) => {
        ObjSpinnerState.isOn = false;
      }
      ObjSpinnerState.isOn = true;
      reader.readAsBinaryString(scenariosExcelFile);
    },
    async runAdcoVectors() {
      UtilsArray.arrayClear(this.arrProgressReport);
      for (let deal of this.dealName.split(',')) {
        for (let scenario of this.adcoScenarios) {
          const status        = new classStatusItem();
          status.DealName     = deal;
          status.ScenarioName = scenario.Name;
          this.arrProgressReport.push(status);
          let body                = new RequestBodyFactory('BASE', {
            dealName:         deal.trim(),
            settlementDate:   this.settlementDate,
            libor:            [0.02],
            runLoanLevel:     false,
            prepaymentModel:  'LDM',
            hpi:              scenario.Hpi,
            twoYrTsy:         scenario.Tsy2Year,
            tenYrTsy:         scenario.Tsy10Year,
            tuneCpr:          scenario.TuneCpr,
            tuneCdr:          scenario.TuneCdr,
            tuneSeverity:     scenario.TuneSeverity,
            selectedScenario: null
          });
          const simulationOptions = {
            storeScenario:      true,
            scenarioName:       scenario.Name,
            useShallowResponse: true
          };
          const objReq            = new ManagerRequest(
              service.runSimulation,
              service,
              null,
              false,
              false
          );
          const res               = objReq.do(body, simulationOptions);
          status.Result           = objReq;
        }
      }
    },
  },
  components: {
    Datepicker,
    DealPicker,
  }
}
</script>
<style lang="scss" scoped>
#file-xlsx-select {
  display: none;
}
</style>